import React, { FC } from 'react';
import { SvgProps } from '../interfaces/Icon'; // Adjust the path to SvgProps if needed

const Refresh: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.023 7.348H20.015L16.834 4.165C15.8099 3.14087 14.5342 2.40439 13.1352 2.02961C11.7362 1.65482 10.2632 1.65493 8.86428 2.02992C7.46534 2.40492 6.18977 3.14159 5.16581 4.16587C4.14184 5.19015 3.40557 6.46595 3.03101 7.865M1.98501 17.644V12.652M1.98501 12.652H6.97701M1.98501 12.652L5.16501 15.835C6.18912 16.8591 7.4648 17.5956 8.8638 17.9704C10.2628 18.3452 11.7358 18.3451 13.1347 17.9701C14.5337 17.5951 15.8092 16.8584 16.8332 15.8341C17.8572 14.8099 18.5934 13.5341 18.968 12.135M20.015 2.356V7.346"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Refresh;
